module.exports = __webpack_public_path__ + "static/media/check-green.0db51e88.svg";